import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CwTextField from '../cwtextfield/CwTextField';
import CwButton from '../cwbutton/CwButton';
import css from './CwFileUpload.scss';
import cx from 'classnames';

class CwFileUpload extends Component {

  handleClick = () => {
    if(this.props.onBeforeClick){
      const result = this.props.onBeforeClick();
      if(result){
        this.inputField.click();
      }
    }
    else {
      this.inputField.click(); // emulate clicking the hidden file input
    }
  };

  handleFileChange = (event) => {
    // Update
    if (!event.target.files || event.target.files.length < 1) {
      return;
    }
    let files = event.target.files;

    if (this.props.hasTextField && this.props.onChange) {
      if (event.target.files.length > 1) {
        this.props.onChange(files.length + " files");
      }
      else {
        this.props.onChange(files[0].name);
      }
    }

    if (this.props.onFileChanged) {
      this.props.onFileChanged(files);
    }
  }

  render() {

    const fileUploadClass = cx(
    css.wrap,
    {
      [css.wrapWithTextField]: this.props.hasTextField && !this.props.disabled,
      [css.wrapWithTextFieldInvalid]: this.props.hasTextField && this.props.invalid,
      [css.wrapDisabled]: this.props.disabled && this.props.hasTextField
    }
  );

    return (
      <div className={fileUploadClass} tabIndex={0}>
        <input
          className={css.file}
          accept={this.props.accept}
          type='file'
          tabIndex='-1'
          ref={(input) => this.inputField = input}
          onChange={this.handleFileChange}
          multiple={this.props.multiple}
        />
        {this.props.hasTextField ? <CwTextField
          value={this.props.value}        
          tabIndex={-1}
          onChange={this.props.onChange}
          readOnly={this.props.readOnly}
          className={css.inputFileText}
        /> : null}
        <CwButton
          cwId={this.props.cwId}
          className={this.props.buttonClassName}
          disabled={this.props.disabled}
          value={this.props.text}
          onClick={this.handleClick}
          icon={this.props.icon}
          topIcon={this.props.topIcon}
          isStandard={this.props.isStandard}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          tabIndex={-1}
        />
      </div>
    );
  }
}

CwFileUpload.propTypes = {
  /**
   *  Function that is called before the input field opens.
   *  Should return a boolean that determines whether the
   *  input field opens or not.
   */
  onBeforeClick: PropTypes.func,
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Callback fired when files are chosen for upload
   */
  onChange: PropTypes.func,
  /**
   * Determines which file types can be uploaded
   * accepts file extensions, media types, and 
   * audio/*|video/*|image/*
   */
  accept: PropTypes.string,
  /**
   * Renders a textfield to the left of the button if true
   */
  hasTextField: PropTypes.bool,
  /**
   * Used to control button styling
   */
  isStandard: PropTypes.bool,
  /**
   * Optional icon placed on left side of button
   */
  icon: PropTypes.string,
  /**
   * Optional icon placed on top of button
   */
  topIcon: PropTypes.string,
  /**
   * CSS class name to be used for styling the button
   */
  buttonClassName: PropTypes.string,
  /**
   * Allows multiple file upload if true
   */
  multiple: PropTypes.bool,
  /**
   * Call fired when the button is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the button is blured
   */
  onBlur: PropTypes.func,
  /**
   * Text for button
   */
  text: PropTypes.string,
  /**
   * Controls whether the file upload is disabled
   */
  disabled: PropTypes.bool,
  /**
   * Text displayed in text field
   */
  value: PropTypes.string,
  /**
   * Callback fired when a new file is selected
   */
  onFileChanged: PropTypes.func,
  /**
   * Controls if the text field is read only
   */
  readOnly: PropTypes.bool,
  /**
   * Used to control if text field is valid
   */
  invalid: PropTypes.bool,
};

CwFileUpload.defaultProps = {
  accept: '',
  hasTextField: true,
  buttonClassName: css.browseButton
};

export default CwFileUpload;


// WEBPACK FOOTER //
// ./src/components/cwfileupload/CwFileUpload.jsx